import { useResponsive } from 'hooks/useResponse'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { RowFixed } from '../../../components/Row'
import Flex from '../../components/Box/Flex'
import LangSelector from './components/LangSelector'
import UserBlock from './components/UserBlock'
import { SIDEBAR_WIDTH_FULL, SIDEBAR_WIDTH_REDUCED } from './config'
import { NavProps } from './types'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

const StyledNav = styled.nav<{ showMenu: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  transition: top 0.1s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 32px;
  padding-right: 24px;
  width: 100%;
  background-color: ${({ theme }) => theme.nav.background};
  border-bottom: 1px solid rgba(115, 126, 141, 0.16);
  z-index: 20;
  transform: translate3d(0, 0, 0);
  height: 60px;
`

const BodyWrapper = styled.div`
  position: relative;
  display: flex;
`

const Inner = styled.div<{ isPushed: boolean; showMenu: boolean }>`
  flex-grow: 1;
  margin-top: ${({ showMenu }) => (showMenu ? `0px` : 0)};
  // transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translate3d(0, 0, 0);
  max-width: 100%;

  ${({ theme }) => theme.mediaQueries.nav} {
    margin-left: ${({ isPushed }) => `${isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED}px`};
    max-width: ${({ isPushed }) => `calc(100% - ${isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED}px)`};
  }
`

const MojitoGameLogo = styled.img`
  width: 108px;
  height: 36px;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 42px;
    height: auto;
  }
`

const Menu: React.FC<NavProps> = ({ account, login, logout, langs, setLang, currentLang, pendingCount, children }) => {
  const { isMobile } = useResponsive()
  const [showMenu] = useState(true)

  return (
    <Wrapper>
      <StyledNav showMenu={showMenu}>
        <RowFixed>
          <Link to="/">
            <MojitoGameLogo
              src={
                isMobile
                  ? '/images/mojito-games-logo.png'
                  : '/images/mojito-games-logo-with-text.png'
              }
              alt="mojito-game-logo"
            />
          </Link>
        </RowFixed>
        {!!login && !!logout && (
          <Flex alignItems="center">
            <LangSelector currentLang={currentLang} langs={langs} setLang={setLang} />
            <UserBlock pendingCount={pendingCount} account={account} login={login} logout={logout} />
          </Flex>
        )}
      </StyledNav>
      <BodyWrapper>
        <Inner isPushed={false} showMenu={showMenu}>
          {children}
        </Inner>
      </BodyWrapper>
    </Wrapper>
  )
}

export default Menu
